import Table from "react-bootstrap/Table";
import Pagination from "react-bootstrap/Pagination";
import currency from "currency.js";
import Avatar from "../../common/Avatar";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "../../styles.css";

const SubscribersTable = (props) => {
  const {
    subscribers,
    columns,
    page,
    pageItems,
    total,
    orderBy,
    setPage,
    setOrderBy
  } = props;

  const PaginationContainer = () => {
    const isDisabled = page > 1 ? false : true;
    return (
      <Pagination style={{ justifyContent: "flex-end", alignItems: "center" }}>
        <span className="mr-3">
          {total} item {total > 1 ? "s" : ""}
        </span>
        <Pagination.First disabled={isDisabled} className="mr-1" />
        <Pagination.Prev disabled={isDisabled} />
        <div className="mx-2 d-flex flex-row align-items-center justify-content-center w-auto">
          <div className="mr-1" style={{ width: 35 }}>
            <input
              type="text"
              className="pagination-input"
              onChange={(e) => setPage(e.target.value)}
              value={page}
            />
          </div>
          of {pageItems}
        </div>
        <Pagination.Next />
        <Pagination.Last className="ml-1" />
      </Pagination>
    );
  };

  return (
    <div className="w-100">
        <div className="text-right my-2">
            {PaginationContainer()}
        </div>
        <div className="pu-table-container">
            <Table size="sm" striped hover responsive>
            <thead>
                <tr>
                {columns.map((column) => (
                    <th key={column}>
                    {column}{" "}
                    {column == "Username" &&
                    orderBy == "ASC" ? (
                        <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            setOrderBy("DESC");
                        }}
                        style={{ fontSize: "10px" }}
                        >
                        <FontAwesomeIcon icon={["fas", "chevron-down"]}/>
                        </a>
                    ) : (
                        ""
                    )}
                    {column == "Username" &&
                        orderBy == "DESC" ? (
                        <a href="#"
                            onClick={(e) => {
                            e.preventDefault();
                            setOrderBy("ASC");
                            }}
                            style={{ fontSize: "10px" }}
                        >
                            <FontAwesomeIcon icon={["fas", "chevron-up"]}/>
                        </a>
                        ) : (
                        ""
                    )}
                    </th>
                ))}
                </tr>
            </thead>

            <tbody>
                {subscribers.map((subscriber) => {
                return (
                    <tr key={subscriber.user.id}>
                    <td>
                        <Avatar pu={subscriber.user} size="25" className="mr-2"/>{" "}
                        <Link to={`/${subscriber.user.login}`}>
                            {subscriber.user.login}
                        </Link>
                    </td>
                    <td>
                        {currency(subscriber.history == 'yearly' ? subscriber.year_one : subscriber.month_one).format()}
                    </td>
                    <td>
                        {currency(subscriber.history == 'yearly' ? subscriber.year_two : subscriber.month_two).format()}
                    </td>
                    <td>
                        {currency(subscriber.history == 'yearly' ? subscriber.year_three : subscriber.month_three).format()}
                    </td>
                    <td>
                        {currency(subscriber.history == 'yearly' ? subscriber.year_four : subscriber.month_four).format()}
                    </td>
                    <td>
                        {currency(subscriber.history == 'yearly' ? subscriber.year_five : subscriber.month_five).format()}
                    </td>
                    <td>
                        {currency(subscriber.history == 'yearly' ? subscriber.year_six : subscriber.month_six).format()}
                    </td>
                    <td>
                        {currency(subscriber.history == 'yearly' ? subscriber.year_seven : subscriber.month_seven).format()}
                    </td>
                    <td>
                        {currency(subscriber.history == 'yearly' ? subscriber.year_eight : subscriber.month_eight).format()}
                    </td>
                    <td>
                        {currency(subscriber.history == 'yearly' ? subscriber.year_nine : subscriber.month_nine).format()}
                    </td>
                    <td>
                        {currency(subscriber.history == 'yearly' ? subscriber.year_ten : subscriber.month_ten).format()}
                    </td>
                    <td>
                        {currency(subscriber.history == 'yearly' ? subscriber.year_eleven : subscriber.month_eleven).format()}
                    </td>
                    <td>
                        {currency(subscriber.history == 'yearly' ? subscriber.year_twelve : subscriber.month_twelve).format()}
                    </td>
                    </tr>
                );
                })}
            </tbody>

            <tfoot>
                <tr>
                {columns.map((column) => (
                    <th key={column}>
                    {column}
                    </th>
                ))}
                </tr>
            </tfoot>
            </Table>
        </div>
        {PaginationContainer()}
    </div>
  );
};

export default SubscribersTable;
